var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMissoes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.459,
    height: 39.608,
    viewBox: "0 0 40.459 39.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.558,1.365,33.62,11.606,22.572,13.254a2.492,2.492,0,0,0-1.339,4.223l7.993,7.967L27.336,36.7a2.43,2.43,0,0,0,3.509,2.607l9.884-5.314,9.884,5.314A2.432,2.432,0,0,0,54.122,36.7L52.231,25.444l7.993-7.967a2.492,2.492,0,0,0-1.339-4.223L47.837,11.606,42.9,1.365a2.4,2.4,0,0,0-4.341,0Z",
    transform: "translate(-20.5 0.013)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMissoes);
export default __webpack_public_path__ + "static/media/icon-missoes.e1506d79.svg";
export { ForwardRef as ReactComponent };